import { ModelConceptRelationship } from 'src/containers/ProjectDiagram/types/data';
import { LinkData, Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptRelationship,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { removeDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { removeLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { getLabelKeyFromRelationshipKey } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/createModelConceptRelationshipLabel';
import { removePropertyType } from 'src/containers/ProjectDiagram/utils/propertyType/removePropertyType';

// use useRemoveModelConceptRelationship() since it also
// clears the diagram and closes drawers if necessary
export const removeModelConceptRelationship =
  (data: ModelConceptRelationship) => (model: Model) => {
    if (!data.to || !data.from) {
      removeModelConceptRelationshipInstance(data)(model);
    } else {
      const existingRelationships = model.linkDataArray.filter(
        (link) => isModelConceptRelationship(link) && link.value === data.value
      ) as ModelConceptRelationship[];
      existingRelationships.forEach((existingRelationship) => {
        removeModelConceptRelationshipInstance(existingRelationship)(model);
      });
    }

    const hasRemainingLinks = model.linkDataArray.some(
      (link) => isModelConceptRelationship(link) && link.value === data.value
    );
    if (!hasRemainingLinks) {
      removeDescriptionForIri(data.value)(model);
      removeLabelForIri(data.value)(model);
      removePropertyType(data.value)(model);
    }
  };

export const removeModelConceptRelationshipInstance =
  (data: ModelConceptRelationship) => (model: Model) => {
    model.removeLinkData(data);

    const labelKey = getLabelKeyFromRelationshipKey(data.key);
    const labelData = model.nodeDataArray.find((node) => node.key === labelKey);
    if (labelData) {
      model.removeNodeData(labelData);
    }

    const linkDataToRemove: LinkData[] = [];
    // do not remove items directly while iterating over `linkDataArray`
    model.linkDataArray.forEach((linkData) => {
      if (
        isRelationshipMapping(linkData) &&
        linkData.relationshipIri === data.value
      ) {
        const sourceClassMapping = model.linkDataArray.find(
          (linkDataB) => linkDataB.key === linkData.from
        );
        if (
          data.from &&
          (sourceClassMapping?.to === data.from ||
            linkData.fromClassIri === getModelConceptClassValue(data.from))
        ) {
          linkDataToRemove.push(linkData);
        }

        const targetClassMapping = model.linkDataArray.find(
          (linkDataB) => linkDataB.key === linkData.to
        );
        if (
          data.to &&
          (targetClassMapping?.to === data.to ||
            linkData.toClassIri === getModelConceptClassValue(data.to))
        ) {
          linkDataToRemove.push(linkData);
        }
      }
    });
    linkDataToRemove.forEach((linkData) => model.removeLinkData(linkData));
  };
